import React, { Component } from 'react';
import { connect } from "react-redux";
import { Button, Row, Col, Grid, Checkbox } from 'react-bootstrap';
import { setLoader, setShowError, setErrorType } from "../../redux/actionCreators";
import './documentReview.css';
import { FaRegSadTear } from "react-icons/fa";
import { ScaleLoader } from 'react-spinners';
import { ReactComponent as DownloadIcon } from '../../resources/images/download-new.svg';
import FooterContainer from '../../components/footer/FooterContainer';
import MainButton from '../../components/buttons/main_button/MainButton';
const TIME_TO_UPDATE_IFRAME = 3000;

const PROCESS_TAB = 0;

class PDFViewer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pages: [],
            disableButton: true,
            iframeKey: 'iframe-0',
            viewer: {
                path: 'https://drive.google.com/viewerng/viewer',
                pid: 'explorer',
                efh: 'false',
                a: 'v',
                chrome: 'false',
                embedded: 'true',
            },
            file: this.props.documents[0],
            files: this.props.documents || [],
            viewed: this.props.documents.length > 1 ? [1].concat(new Array(this.props.documents.length - 1).fill(0)) : [1],
            iframeLoading: true,
        };
        this.iframe = React.createRef();
    }

    componentDidMount() {
        this.props.setLoader(false);
        this.iframeTimeoutId = setInterval(
            this.updateIframe.bind(this), TIME_TO_UPDATE_IFRAME
        );
    }

    onClickCheckbox = (e) => {
        this.setState({
            disableButton: !e.target.checked
        });
    }


    onClickButton = (file, key) => {
        clearInterval(this.iframeTimeoutId);
        const viewed = new Array(this.props.documents.length).fill(0);
        viewed[key] = 1;
        this.setState({
            file,
            viewed,
            iframeLoading: true,
        });
        this.iframeTimeoutId = setInterval(
            this.updateIframe.bind(this), TIME_TO_UPDATE_IFRAME
        );
    }


    loadedIframe = async (response, status, xhr) => {
        clearInterval(this.iframeTimeoutId);
        await this.setState({
            iframeLoading: false,
        });
    }

    updateIframe = () => {
        this.setState({
            iframeKey: this.state.iframeKey + '1',
        });

    }

    render() {
        return (
                <Grid>
                    <Row>
                        <Col sm={12}>
                            <div className={'pdf-wrapper'} ref={(document) => this.document = document}>
                                <div>
                                    <div className={`loader-pdf-error ${this.state.iframeLoading ? 'hide' : 'show'}`}>
                                        <FaRegSadTear className='icon' />
                                        <p>Ha ocurrido un error en la previsualización del documento, por favor vuelve a presionar el botón o descárguelo en el botón correspondiente </p>
                                    </div>
                                    <div className={'loader-pdf'}>
                                        <ScaleLoader
                                            loading={this.state.iframeLoading}
                                            color={'#0cb7ef'}
                                        />
                                    </div>

                                    <div className={`iframe-content ${this.props.activeTab === PROCESS_TAB ? 'pdf-resume' : 'pdf-full'}`}>
                                        <iframe
                                            title={'Documentos'}
                                            src={`${this.state.viewer.path}?url=${this.state.file}&embedded=${this.state.viewer.embedded}&pid=${this.state.viewer.pid}&efh=${this.state.viewer.efh}&a=${this.state.viewer.a}&chrome=${this.state.viewer.chrome}`}
                                            className={`iframe-doc hide ${this.state.iframeLoading ? 'hide' : 'show'}`}
                                            ref={this.iframe}
                                            onLoad={this.loadedIframe}
                                            onError={this.updateIframe}
                                            key={this.state.iframeKey}
                                        >
                                            <Button bsStyle="link" onClick={this.updateIframe}>Algo ocurrió con la descarga, Presiona acá para volver a intentar</Button>
                                        </iframe>
                                    </div>
                                    { this.props.downloadDocument ? 
                                    <div className='download-container'>
                                    <a href={this.state.file} target={'download'}  >
                                        <DownloadIcon className='pdf-icon'/>
                                        Descargar Documento
                                    </a>
                                    </div>:
                                    <React.Fragment/>
                                    }
                                </div>
                            </div>
                        </Col>
                    </Row>
                    { this.props.clauseAndNextButton ?
                    <Row>
                        <Col sm={12} className={'confirm-form'}>
                            <Checkbox onClick={this.onClickCheckbox}>
                                    {this.state.files.length === 1 ?
                                        <div className='pdf-terms'>Declaro que he leído y revisado el documento que aquí se lista</div>
                                    :
                                        <div className='pdf-terms'>Declaro que he leído y revisado los {this.state.files.length} documentos que aquí se listan</div>
                                    }
                            </Checkbox>
                        </Col>
                        <FooterContainer>
                            <MainButton
                                onClick={this.props.nextStep}
                                disabled={this.state.disableButton}
                                text={this.props.buttonText}
                            />
                        </FooterContainer>
                    </Row>:
                    <React.Fragment/>
                    }
                </Grid>
        );
    }
}


const mapStateToProps = state => {
    return {
        stepInfo: state.stepInfo,
        loader: state.loader,
        showError: state.showError,
        errorType: state.errorType,
        documents: state.documents,
        source: state.source,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setLoader(loader) {
            dispatch(setLoader(loader));
        },
        setErrorType(errorType) {
            dispatch(setErrorType(errorType));
        },
        setShowError(showError) {
            dispatch(setShowError(showError));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PDFViewer);